// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Sidebar_Navbar__3y9on","Navbar__images":"Sidebar_Navbar__images__128ON","Navbar__toggler":"Sidebar_Navbar__toggler__1oM5w"};